module.exports = __webpack_public_path__ + "static/media/connect-private-app.d27e5ad2.svg";